export const openHelpExplorer = (openInPlace: boolean, userLanguage?: string) => {
    let exploreUrl = "https://exploredocubird-en.helpscoutdocs.com";
    const userLang = userLanguage || navigator.language || "en";
    if (userLang.toLowerCase().indexOf("nl") === 0) {
        exploreUrl = "https://exploredocubird-nl.helpscoutdocs.com";
    }

    if (openInPlace) {
        window.location.replace(exploreUrl);
    }
    else {
        window.open(exploreUrl, "_blank");
    }
};